import { z } from "zod";

import http from "@/services/http";

// GET /store/popular-new-catalogs (apollo-middleware-service). Shared shape with
// unauthService/subscriptions.ts's popularNewResponse (same conceptual endpoint hit through the
// ciscou-unauth-api proxy for unauth) - that file imports popularProduct from here.
export const popularProduct = z.object({
  gui: z.number(),
  status: z.string(),
  product_name: z.string(),
  product_title: z.string(),
  product_type: z.string(),
  ga_date: z.string(),
});

export const popularNewResponse = z.object({
  popular_catalogs: z.array(popularProduct),
  new_catalogs: z.array(popularProduct),
});

export type PopularTypes = z.infer<typeof popularProduct>;

export type PopularResponse = z.infer<typeof popularNewResponse>;

export async function getPopularNew() {
  const { data } = await http().get(
    `${globalThis.env.API_APOLLO_MIDDLEWARE}/store/popular-new-catalogs`
  );
  return popularNewResponse.parse(data);
}
